import { render, staticRenderFns } from "./AiAssistanceSection.vue?vue&type=template&id=ba1ca740&scoped=true"
import script from "./AiAssistanceSection.vue?vue&type=script&lang=js"
export * from "./AiAssistanceSection.vue?vue&type=script&lang=js"
import style0 from "./AiAssistanceSection.vue?vue&type=style&index=0&id=ba1ca740&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1ca740",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba1ca740')) {
      api.createRecord('ba1ca740', component.options)
    } else {
      api.reload('ba1ca740', component.options)
    }
    module.hot.accept("./AiAssistanceSection.vue?vue&type=template&id=ba1ca740&scoped=true", function () {
      api.rerender('ba1ca740', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/AiAssistanceSection/AiAssistanceSection.vue"
export default component.exports